/**
 * Copyright (c) 2021 - 2023, Kodit Doo
 * Created by kodit-marko on 03.04.2023.
 */

import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Guid } from 'guid-typescript';
import { SefService } from '@kodit/core/services';
import { Subscription } from 'rxjs';
import { IGetSefHealthStatusResponse } from '@kodit/core/data-api';

export enum ButtonSeverity {
  PRIMARY = 'p-button-primary',
  SUCCESS = 'p-button-success',
  DANGER = 'p-button-danger'
}

@Component({
  selector: 'kodit-button',
  templateUrl: './button.html',
  styleUrls: ['./button.scss'],
})
export class ButtonComponent implements OnInit, OnDestroy, OnChanges {
  /** Subs */
  private _subs: Subscription = new Subscription();

  /** Props */
  isSefActive: boolean;
  btnOriginalDisabledFlag: boolean;

  /** I/O */
  @Input() btnLabel: string;
  @Input() btnIcon: string;
  @Input() btnClass: string;
  @Input() isBtnDisabled: boolean;
  @Input() shouldDisableWhenSefInactive: boolean;
  @Input() btnId: string;
  @Input() btnType: string;
  @Input() btnTooltip: string;
  @Input() btnTooltipPosition: string;
  @Input() btnSeverity: string;
  @Output() btnClicked: EventEmitter<any>;

  constructor(private _sefService: SefService) {
    this.isSefActive = false;
    this.btnId = `kodit-btn-${Guid.create()}`;
    this.btnLabel = '';
    this.btnType = 'button';
    this.btnIcon = '';
    this.btnClass = '';
    this.btnTooltip = '';
    this.btnTooltipPosition = 'bottom';
    this.btnOriginalDisabledFlag = false;
    this.isBtnDisabled = false;
    this.shouldDisableWhenSefInactive = false;
    this.btnClicked = new EventEmitter<void>();
    this.btnSeverity = ButtonSeverity.PRIMARY;
  }

  ngOnInit() {
    if (this.shouldDisableWhenSefInactive) {
      this._subs.add(
        this._sefService.getIsSefActive.subscribe(
          (isSefActive: IGetSefHealthStatusResponse) => {
            this.isSefActive = isSefActive.isActive;
            this.isBtnDisabled =
              !isSefActive.isActive || this.btnOriginalDisabledFlag;
          }
        )
      );
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.btnOriginalDisabledFlag = changes?.isBtnDisabled?.currentValue;

    if (changes?.isBtnDisabled && !changes.isBtnDisabled.firstChange) {
      if (
        !changes.isBtnDisabled.currentValue &&
        this.shouldDisableWhenSefInactive &&
        !this.isSefActive
      ) {
        this.isBtnDisabled = true;
      }
    }
  }

  handleBtnClick(event: any) {
    this.btnClicked.emit(event);
  }

  ngOnDestroy() {
    this._subs.unsubscribe();
  }
}
